import { namespace } from 'vuex-class';
import { IDashboardState } from './dashboard.types';

export const Dashboard = namespace('dashboard');

export function getDefaultState(): IDashboardState {
  return {
    activities: null,
  };
}

export enum EDashboardAction {
  LoadActivities = 'loadActivities',
}

export enum EDashboardMutation {
  SetActivities = 'setActivities',
}
